<template>

  <div id="location-finder-app">
      <LocationsMapBox v-if="(Object.keys(locationsJson).length > 0)"
      :locationsJson="locationsJson"
      @isLoaded="isLoaded"
      :getSingleLocation="getSingleLocation"
      />
  </div>
</template>

<script>
import axios from 'axios';
import LocationsMapBox from '@/components/LocationsMapBox';

export default {
  name: 'App',
  components: {
    LocationsMapBox,
  },
  data() {
    return {
     locationsJson: {},
     showLoading: true,
     locationCoordinates: null,
     isMobile: null,
     selectedLocation: null
    }
  },
  mounted() {
    // let element = document.querySelector('#category');
    // let coordinates = document.querySelector('#post-coordinates');
    // document.querySelector('#clickMe').addEventListener('change', this.btnClicked);
    axios.get('https://www.statewidebearings.com.au/wp-json/wp/v2/locations/coordinates')
      .then((r) => this.locationsJson = this.convertToGeoJson(r.data));
  },
  methods: {
    getSelectedLocation() {
      const locationCategory = document.getElementById("location-category").value;
      if (locationCategory != '' ) {
        this.selectedLocation = locationCategory;
        return this.selectedLocation;
      }
    },
    convertToGeoJson(data) {
      const geojson = {
        type: "FeatureCollection",
        features: data.map(item => {
          const latitude = item.postMeta.location_latitude;
          const longitude = item.postMeta.location_longitude;
          return {
            id: item.ID,
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [parseFloat(longitude[0]), parseFloat(latitude[0]) ]
            },
            category: item.postMeta.location_region
          };
        })
      };
      return geojson;
    },
    isLoaded() {
      this.showLoading = false
    },
    getSingleLocation(feature, type) {
    return axios({
      url:  `https://www.statewidebearings.com.au/wp-json/wp/v2/${type}/${feature.id}?_embed`,
      method: 'get',
      timeout: 8000,
      headers: {
          'Content-Type': 'application/json',
      }
    })
    .then(res => res.data)
    .catch (err => console.error(err))
    },
    isLoaded() {
      this.showLoading = false
    },
    getLocationByCategory(feature, type) {
    return axios({
      url:  `https://www.statewidebearings.com.au/wp-json/wp/v2/${type}/${feature.id}?_embed`,
      method: 'get',
      timeout: 8000,
      headers: {
          'Content-Type': 'application/json',
      }
    })
    .then(res => res.data)
    .catch (err => console.error(err))
    },
    isLoaded() {
      this.showLoading = false
    },
  }
};
</script>

<style scoped>

#location-finder-app {
  width: 100%;
}

</style>
